<template>
  <!-- FIXME: Regular slider and pricle slider track-btn moves together if you want change one slider value -->
  <div class="slider">
    <h6 class="slider__title">{{ name }}</h6>
    <KaaliSlider
      v-if="type === 'kaali'"
      :min="min"
      :max="max"
      :step="1"
      :name="name"
      v-on:min-changed="updateMin"
      v-on:max-changed="updateMax"
    />
    <p class="slider__selected">
      {{ formatNumber(displayedMin) }} - {{ formatNumber(displayedMax) }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.slider {
  &__title {
    margin-bottom: 2rem;
  }

  &__selected {
    margin-top: 2rem;
  }
}
</style>

<script>
import KaaliSlider from "@/components/general-ui/sliders/Kaali.vue";

export default {
  name: "Slider",
  components: {
    KaaliSlider
  },
  props: {
    name: String,
    min: Number,
    max: Number
  },
  data() {
    return {
      type: ws_vue_store.config.slider,
      fixedLength: ws_vue_store.fixed_length,
      sliderMin: 0,
      sliderMax: 0
    };
  },
  mounted: function() {
    this.sliderMin = this.min;
    this.sliderMax = this.max;
  },
  computed: {
    displayedMin() {
      if (this.sliderMin > this.min) {
        return this.sliderMin;
      }
      return this.min;
    },
    displayedMax() {
      if (this.sliderMax < this.max && this.sliderMax >= this.sliderMin) {
        return this.sliderMax;
      }
      return this.max;
    }
  },
  methods: {
    formatNumber(value) {
      return `${value
        .toFixed(this.fixedLength)
        .toString()
        .replace(".", ",")} €`;
    },
    updateMin(value) {
      this.sliderMin = value;
      this.$emit("min-changed", { value, name });
    },
    updateMax(value) {
      this.sliderMax = value;
      this.$emit("max-changed", { value, name });
    }
  }
};
</script>
